import { ADD_TOAST, REMOVE_TOAST } from '../actions/toastActions';

/*
* Toast Schema:
*   errorCode: Error code
*   toastType: error, warning, success, info(default)
*   title: Toast title
*   message: Toast message
*/

export default function(state = [], action) {
  switch (action.type) {
    case ADD_TOAST:
      return [...state, action.toast];
    case REMOVE_TOAST:
      return state.filter(existingToast => existingToast.errorCode !== action.toast.errorCode);
    default:
      return state;
  }
}
